import PropTypes from 'prop-types';
import React from 'react';
import { Form } from 'semantic-ui-react';
import { TCF_CONSENT_FIELDS, TCF_USER_CONSENT_OPTIONS, TCF_USER_EXT_CONSENT_OPTIONS } from '../constants';


class TcfConsent extends React.Component {
  constructor(props) {
    super(props);
    const { bidder: { request_processing: requestProcessing = {}} } = props;
    const { tcf_consent_settings: tcfSettings = {}} = requestProcessing;
    this.state = {
      request_processing: requestProcessing,
      user_consent_enabled: tcfSettings.user_consent? true : false,
      user_consent: tcfSettings.user_consent,
      user_ext_consent_enabled: tcfSettings.user_ext_consent? true : false,
      user_ext_consent: tcfSettings.user_ext_consent
    };
  }

  componentWillReceiveProps(nextProps) {
    const { bidder: { request_processing: requestProcessing = {}} } = this.props;
    const { tcf_consent_settings: tcfSettings = {} } = requestProcessing;

    const { bidder: { request_processing: newRequestProcessing = {}} } = nextProps;
    const { tcf_consent_settings: newTcfSettings } = newRequestProcessing;

    if (tcfSettings && newTcfSettings) {
      if (
        tcfSettings.user_consent !== newTcfSettings.user_consent ||
        tcfSettings.user_ext_consent !== newTcfSettings.user_ext_consent
      ) {
        this.setState({
            user_consent_enabled: newTcfSettings.user_consent? true : false,
            user_consent: newTcfSettings.user_consent,
            user_ext_consent_enabled: newTcfSettings.user_ext_consent? true : false,
            user_ext_consent: newTcfSettings.user_ext_consent
        });
      }
    }
  }

  setTcfSettings(tcfSettings) {
    const { bidder: { id, request_processing: requestProcessing = {}} } = this.props;
    this.props.setBidder(id, {
      request_processing: {
        ...requestProcessing, 
        tcf_consent_settings: tcfSettings
      }
    })
  }

  render() {
    const {
        user_consent_enabled,
        user_consent,
        user_ext_consent_enabled,
        user_ext_consent
    } = this.state;
    
    const onUserConsentEnabled = (event, ownProps) => {
      const defaultValue = ownProps.checked? TCF_CONSENT_FIELDS.TCFStringConsent : null;
      this.setState({
        ...this.state,
        user_consent_enabled: ownProps.checked,
        user_consent: defaultValue
      })
      this.setTcfSettings({
          user_consent: defaultValue,
          user_ext_consent
      })
    }

    const onUserExtConsentEnabled = (event, ownProps) => {
        const defaultValue = ownProps.checked? TCF_CONSENT_FIELDS.BinaryConsent : null;
        this.setState({
          ...this.state,
          user_ext_consent_enabled: ownProps.checked,
          user_ext_consent: defaultValue
        })
        this.setTcfSettings({
            user_consent,
            user_ext_consent: defaultValue          
        })
      }

    const onChangeUserConsent = (event, ownProps) => {
      this.setState({
        ...this.state,
        user_consent_enabled: ownProps.value? true : false,
        user_consent: ownProps.value
      })
      this.setTcfSettings({
        user_consent: ownProps.value,
        user_ext_consent,
      })
    }

    const onChangeUserExtConsent = (event, ownProps) => {
        this.setState({
          ...this.state,
          user_ext_consent_enabled: ownProps.value? true : false,
          user_ext_consent: ownProps.value
        })
        this.setTcfSettings({
          user_consent,
          user_ext_consent: ownProps.value,
        })
      }


    return (
      <div>
        <Form.Group>
            <Form.Field style={{padding: '25px'}}>
                <Form.Checkbox 
                toggle 
                label="enabled" 
                onChange={onUserConsentEnabled}
                checked={user_consent_enabled}
                />
            </Form.Field>
            <Form.Field>
                <Form.Select 
                  label="user.consent"
                  value={user_consent}
                  onChange={onChangeUserConsent}
                  options={TCF_USER_CONSENT_OPTIONS}
                />
            </Form.Field>
        </Form.Group>
        <Form.Group>
            <Form.Field style={{padding: '25px'}}>
                <Form.Checkbox 
                toggle 
                label="enabled" 
                onChange={onUserExtConsentEnabled}
                checked={user_ext_consent_enabled} 
                />
            </Form.Field>
            <Form.Field>
                <Form.Select 
                  label="user.ext.consent"
                  value={user_ext_consent}
                  onChange={onChangeUserExtConsent}
                  options={TCF_USER_EXT_CONSENT_OPTIONS}
                />
            </Form.Field>
        </Form.Group>
      </div>
    );
  }
}

export default TcfConsent;

TcfConsent.defaultProps = {
  bidder: {},
  setBidder: () => {},
};

TcfConsent.propTypes = {
  bidder: PropTypes.shape({}),
  setBidder: PropTypes.func,
};
